import React from "react";
import { useAppContext } from "./AppContext";

import Box from "./Box";
import Image from "./Image";
import AspectRatioBox from "./AspectRatioBox";
import OpenFullSizeImageButton from "./OpenFullSizeImageButton";
import PropTypes from "prop-types";
import SquareImage from "./SquareImage";

function DesktopProductImage({ image, sizes, buttonStyle }) {
  const { setProductImageOverlayOpen, setClickedImage } = useAppContext();

  return (
    <Box key={image.url}>
      <Box position="relative">
        <Box position="absolute" bottom={0} right={0} zIndex={2}>
          <OpenFullSizeImageButton
            buttonStyle={buttonStyle}
            onClick={() => {
              setProductImageOverlayOpen(true);
              setClickedImage(image.url);
            }}
          />
        </Box>
        <SquareImage src={image.url} alt={image.name} sizes={sizes} />
      </Box>
    </Box>
  );
}

DesktopProductImage.propTypes = {
  image: PropTypes.shape({
    url: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  sizes: PropTypes.string.isRequired,
  buttonSize: PropTypes.string,
};

export default DesktopProductImage;
